function trimStart(value?: string, character?: string) {
  if (!value) return '';
  if (value && character === undefined) {
    return value.trimLeft();
  }
  if (!value || !character) {
    return (value || '');
  }

  let trimmed = value;

  while (trimmed.charAt(0) === character) {
    trimmed = trimmed.substring(1);
  }

  return trimmed;
}

export default trimStart;
